import request from '@/utils/httpClient'
import { InvoiceCreateParams, InvoiceUpdateParams } from '@/types/domain/invoice'

// 创建发票
export function createInvoice(data: InvoiceCreateParams) {
  return request({
    url: 'invoice',
    method: 'POST',
    data
  })
}

// 更新发票
export function updateInvoice(id: number, data: InvoiceUpdateParams) {
  return request({
    url: `invoice/${id}`,
    method: 'put',
    data
  })
}

// 发票退回
export function rejectInvoice(id: number, data?: object) {
  return request({
    url: `invoice/${id}/actions/reject`,
    method: 'put',
    data
  })
}

// 发票登记
export function invoiceDetail(id: number, data?: object) {
  return request({
    url: `invoice/${id}/actions/detail`,
    method: 'post',
    data
  })
}

// 发票登记列表
export function invoiceDJList(id: number) {
  return request({
    url: `invoice/${id}/actions/detail`,
    method: 'get'
  })
}

export function cancelTicket(id: number, comment: string) {
  return request({
    url: `invoice/${id}/actions/applyCancel`,
    method: 'put',
    data: { comment }
  })
}

// 申请退回
export function applyBackTicket(id: number, data?: object) {
  return request({
    url: `invoice/${id}/actions/applyBack`,
    method: 'put',
    data
  })
}
